/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type GovernanceProposalCreatedEvent = {
  proposal: Address;
  proposalId: bigint;
  proposer: Address;
  title: string;
};

export type GovernanceProposalCreatedEventArgs = {
  proposal: Address;
  proposalId: number | bigint;
  proposer: Address;
  title: string;
};

export function getGovernanceProposalCreatedEventEncoder(): Encoder<GovernanceProposalCreatedEventArgs> {
  return getStructEncoder([
    ["proposal", getAddressEncoder()],
    ["proposalId", getU64Encoder()],
    ["proposer", getAddressEncoder()],
    ["title", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
  ]);
}

export function getGovernanceProposalCreatedEventDecoder(): Decoder<GovernanceProposalCreatedEvent> {
  return getStructDecoder([
    ["proposal", getAddressDecoder()],
    ["proposalId", getU64Decoder()],
    ["proposer", getAddressDecoder()],
    ["title", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
  ]);
}

export function getGovernanceProposalCreatedEventCodec(): Codec<
  GovernanceProposalCreatedEventArgs,
  GovernanceProposalCreatedEvent
> {
  return combineCodec(
    getGovernanceProposalCreatedEventEncoder(),
    getGovernanceProposalCreatedEventDecoder(),
  );
}
